<button (click)="onClicked()">
  <div class="flex justify-center items-center">
    <i-lucide [img]="icon()"></i-lucide>
    <a class="text-lg ml-2">{{ name() }}</a>
  </div>
</button>
